import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TCardioActivity } from "models/facility-options";

import {
  CardioActivityListPayload,
  FacilityOptionsState,
  FacilitySettingsPayload,
} from "./facilityOptionsActions";

const initialState: FacilityOptionsState = {
  cardioActivityList: [],
  cardioActivityListPagination: {},
  loading: false,
  selectedCardioActivityList: [],
  settings: { OPTIONS: {}, PAY_SCHEDULE: [] },
  showClassAddEditModal: false,
};

export const facilityOptionsSlide = createSlice({
  initialState,
  name: "facility-options",
  reducers: {
    resetCardioActivitiesList: (state) => {
      state.cardioActivityList = [];
    },
    setCardioActivities: (state, action: PayloadAction<CardioActivityListPayload>) => {
      state.cardioActivityListPagination = action.payload.pagination;
      if (action.payload.pagination?.current_page === 1) {
        state.cardioActivityList = action.payload.data;
      } else {
        state.cardioActivityList = [...state.cardioActivityList, ...action.payload.data];
      }
    },
    setCardioActivityCheckedOrUnchecked: (state, action: PayloadAction<TCardioActivity>) => {
      state.cardioActivityList = state.cardioActivityList.map((item) => {
        if (item.id === action.payload.id) {
          item.is_checked = action.payload.is_checked;
        }
        return item;
      });
    },
    setFacilitySettings: (state, action: PayloadAction<FacilitySettingsPayload>) => {
      state.settings = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setSelectedCardioActivities: (state, action: PayloadAction<CardioActivityListPayload>) => {
      state.selectedCardioActivityList = action.payload.data;
    },
    setShowClassAddEditModal: (state, action) => {
      state.showClassAddEditModal = action.payload;
    },
  },
});

export const {
  resetCardioActivitiesList,
  setCardioActivities,
  setCardioActivityCheckedOrUnchecked,
  setFacilitySettings,
  setLoading,
  setSelectedCardioActivities,
  setShowClassAddEditModal,
} = facilityOptionsSlide.actions;
export default facilityOptionsSlide.reducer;
